import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getBillingDetailsApi,
  manageBillingDetailsApi,
} from "helpers/ApiManager";
import { ApiResponse } from "types/ApiResponse";
import {
  BillingDetailArgs,
  BillingDetailsData,
} from "types/payment.invoicing.api";

import { ErrorHandler, SuccessToast } from "utils/toast";

export const getBillingDetails = createAsyncThunk<
  ApiResponse<BillingDetailsData>, // return type
  undefined, // argument type
  { rejectValue: string } // rejected type
>("payment/getBillingDetails", async (params, { rejectWithValue }) => {
  try {
    const response = await getBillingDetailsApi();
    return response;
  } catch (err: any) {
    console.log(err);
    return rejectWithValue(err?.message || "Failed to fetch");
  }
});

export const manageBillingDetails = createAsyncThunk<
  ApiResponse<BillingDetailsData>, // return type
  BillingDetailArgs, // argument type
  { rejectValue: string } // rejected type
>("payment/manageBillingDetails", async (params, { rejectWithValue }) => {
  try {
    const response = await manageBillingDetailsApi(params);
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to manage");
  }
});
